"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBT_WRITE_FAILURE_COPY = exports.DEBT_NOT_PAID_OFF_CONFIRM_BODY_COPY = exports.DEBT_NOT_PAID_OFF_COPY = void 0;
exports.debtNotPaidOffConfirmTitle = debtNotPaidOffConfirmTitle;
exports.debtNotPaidOffConfirmSentence = debtNotPaidOffConfirmSentence;
exports.debtNotPaidOffAriaLabel = debtNotPaidOffAriaLabel;
/**
 * G43 (Paul, 2026-10-23): un-marking a debt that was marked Paid Off, one copy for both
 * clients. Each paid-off row offers "Not paid off"; it asks this one confirm first, and
 * confirming sets the debt back to active, which undoes its rollover (G24, #2084): the
 * freed minimum leaves Debt payoff and the bill returns to Upcoming.
 */
exports.DEBT_NOT_PAID_OFF_COPY = "Not paid off";
/** The confirm's question, naming the debt: "Mark Store card as not paid off?" */
function debtNotPaidOffConfirmTitle(name) {
    return `Mark ${name} as not paid off?`;
}
/** The confirm's second sentence, under the question. */
exports.DEBT_NOT_PAID_OFF_CONFIRM_BODY_COPY = "Its minimum goes back to your bills.";
/** Paul's whole confirm as one string, for a client whose confirm has no title. */
function debtNotPaidOffConfirmSentence(name) {
    return `${debtNotPaidOffConfirmTitle(name)} ${exports.DEBT_NOT_PAID_OFF_CONFIRM_BODY_COPY}`;
}
/**
 * The row action's accessible name, naming the debt, as the row's Remove does
 * ("Remove Store card"). A colon, since "Not paid off Store card" doesn't read.
 */
function debtNotPaidOffAriaLabel(name) {
    return `${exports.DEBT_NOT_PAID_OFF_COPY}: ${name}`;
}
/**
 * A failed debt write, in FP-103's words (`writeFailureCopy`): "Couldn't save the debt."
 * plus what is still true. Web's debt hooks carry these words in their `meta.write`;
 * the phone reads them from here (first used by its "Not paid off", G43).
 */
exports.DEBT_WRITE_FAILURE_COPY = {
    action: "save the debt",
    unchanged: "The debt hasn't changed.",
};
//# sourceMappingURL=debtNotPaidOffCopy.js.map